import { render, staticRenderFns } from "./AutocompletePaciente.vue?vue&type=template&id=163ff1a9&"
import script from "./AutocompletePaciente.vue?vue&type=script&lang=js&"
export * from "./AutocompletePaciente.vue?vue&type=script&lang=js&"
import style0 from "./AutocompletePaciente.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports